import createTableStore from "ds/components/Table/store/useTableStore";

import { WEBHOOKS_TABLE_COLUMNS_CONFIG, WEBHOOKS_TABLE_STORAGE_KEY } from "./constants";

const useWebhooksTableStore = createTableStore({
  storageKey: WEBHOOKS_TABLE_STORAGE_KEY,
  config: WEBHOOKS_TABLE_COLUMNS_CONFIG,
});

export default useWebhooksTableStore;
